<template>
  <div class="container panel-heading">
    <div>
      <img
        style="margin-left: 10px"
        src="../assets/calvert-logo-transparent-background.png"
        alt="Image"
        class="pull-left pointer"
        width="180"
        @click="handleRedirect()"
      />
      <h4
        @click="handleRedirect('/contact')"
        style="margin-right: 10px; margin-top: 30px"
        class="pull-right contact-us-title pointer"
      >
        Contact Us
      </h4>
    </div>
    <div class="shadow-bar"></div>
  </div>
</template>

<script>
export default {
  name: 'ContactUsHeader',
  methods: {
    handleRedirect(urlEndpoint = '') {
      const url = `https://calvertimpact.org${urlEndpoint}`;
      window.location.href = url;
    },
  },
};
</script>

<style>
/* Non-scoped to override Bootstrap container */
@media (max-width: 768px) {
  .container.panel-heading {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}
</style>

<style scoped>
.shadow-bar {
  width: 100%;
  height: 40px;
  box-shadow: inset 0px 35px 20px 0 #fff, inset 0 40px 20px 0px gray;
  margin-top: 70px;
}
.contact-us-title {
  color: rgb(75, 193, 127);
}
.pointer {
  cursor: pointer;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .container {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 16px 20px !important;
  }

  .panel-heading {
    padding: 16px 20px !important;
  }

  img {
    margin-left: 0 !important;
    width: 150px !important;
    height: auto;
  }

  .contact-us-title {
    margin-right: 0 !important;
    margin-top: 24px !important;
    font-size: 18px;
  }

  .shadow-bar {
    margin-top: 50px;
    height: 30px;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 12px 16px !important;
  }

  img {
    width: 130px !important;
  }

  .contact-us-title {
    margin-top: 20px !important;
    font-size: 16px;
  }

  .shadow-bar {
    margin-top: 40px;
    height: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// ContactUsHeader.vue?18b02428